<template>
  <AppLayoutContainerSmall class="newsletter-block" :md-wide="true">
    <AppReCaptchaForm class="newsletter-block__re-captcha-form"
                      :form-id="data.campaign_id"
                      :success-message="data.success_message"
                      type="newsletter"
                      :title="data.title"
    >
      <div v-if="data.text" class="app-rich-text app-rich-text--form" v-html="data.text"></div>
      <AppInputEmail :data="{
        label: 'e-mailadres',
        name: 'email',
        placeholder: data.placeholder,
        required: true
      }" collection="newsletter"/>
    </AppReCaptchaForm>
  </AppLayoutContainerSmall>
</template>

<script setup lang="ts">
import {TNewsletterBlock} from "~/types/block-types";

const props = defineProps<{
  data: TNewsletterBlock
}>()
</script>

<style scoped lang="postcss">
.newsletter-block {
  &__re-captcha-form {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    @mixin app-blue-border-block;
  }
}
</style>
